import { VStack, HStack } from "@gluestack-ui/themed";
import { PersonalAccordionProps } from "@repo/core/components/layout/ProposalAccordion/variants/PersonalAccordion/types";
import { AccordionContainer } from "@repo/core/components/layout/ProposalAccordion/components/AccordionContainer";
import { InfoSection } from "@repo/core/components/layout/ProposalAccordion/components/InfoSection";
import { GenderEnum, MartialStatusEnum } from "@repo/core/enums/proposals";
import {
  martialStatusByValue,
  personTypeByValue
} from "@repo/core/constants/proposals";
import { MustShow } from "@repo/core/components/core/MustShow";
import {
  ProposalTypeEnum,
  proposalTypeOptions
} from "@repo/core/screens/ProposalEffectiveFlows/Credit/DetailsCreditProposal/consts";
import { TIPO_PESSOA } from "@repo/core/services/entities/Proposals";

export const PersonalAccordion = ({
  birthday,
  gender,
  martialStatus,
  mothersName,
  fathersName,
  proposalType,
  documentIdentification,
  personType,
  ...rest
}: PersonalAccordionProps) => {
  const martialStatusLabel =
    martialStatusByValue[martialStatus as MartialStatusEnum];

  const personTypeLabel =
    personTypeByValue[(personType as TIPO_PESSOA) || TIPO_PESSOA.FISICA];

  return (
    <AccordionContainer {...rest}>
      <InfoSection title="Tipo de pessoa" value={personTypeLabel} />

      <InfoSection title="Data de Nascimento" value={birthday} />

      <HStack gap="$4" flex={1}>
        <VStack flex={1}>
          <InfoSection
            title="Gênero"
            value={gender === GenderEnum.MALE ? "Masculino" : "Feminino"}
          />
        </VStack>

        <VStack flex={1}>
          <InfoSection title="Estado Civil" value={martialStatusLabel} />
        </VStack>
      </HStack>

      <MustShow
        isVisible={
          proposalType !== proposalTypeOptions[ProposalTypeEnum.FIDELITY]
        }
      >
        <InfoSection title="Nome da Mãe" value={mothersName} />
        {fathersName ? (
          <InfoSection title="Nome do Pai" value={fathersName} />
        ) : null}
      </MustShow>

      {documentIdentification ? (
        <InfoSection
          title="Documento de identificação"
          value={documentIdentification}
        />
      ) : null}
    </AccordionContainer>
  );
};
